import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  QUESTION_LIST,
  QUESTION_SEARCH_SECTION_LIST,
  QUESTION_ADD,
  QUESTION_DETAIL,
  QUESTION_UPDATE,
  QUESTION_UPLOAD_SET
} from '../../actions';
import {
  QuestionListSuccess,
  QuestionListError,
  QuestionSearchSectionListSuccess,
  QuestionSearchSectionListError,
  QuestionAddSuccess,
  QuestionAddError,
  QuestionDetailSuccess,
  QuestionDetailError,
  QuestionUpdateSuccess,
  QuestionUpdateError,
  QuestionUploadSetSuccess,
  QuestionUploadSetError
} from '../../actions';
 
export function* watchQuestionList() {
  yield takeEvery(QUESTION_LIST, onQuestionList);
}

export function* watchQuestionSearchSectionList() {
  yield takeEvery(QUESTION_SEARCH_SECTION_LIST, onQuestionSearchSectionList);
}

export function* watchQuestionAdd() {
  yield takeEvery(QUESTION_ADD, onQuestionAdd);
}

export function* watchQuestionDetail() {
  yield takeEvery(QUESTION_DETAIL, onQuestionDetail);
}

export function* watchQuestionUpdate() {
  yield takeEvery(QUESTION_UPDATE, onQuestionUpdate);
}

export function* watchQuestionUpload() {
  yield takeEvery(QUESTION_UPLOAD_SET, onQuestionUpload);
}

const onQuestionListAsync  = async (payload) => {
  console.log('onQuestionListAsync')
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/question/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onQuestionUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/question/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onQuestionSearchSectionListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/section', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onQuestionAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/question/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onQuestionDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/question/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onQuestionUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/question/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onQuestionList(data) {
  try {
    const response = yield call(onQuestionListAsync, data.payload);
    yield put(QuestionListSuccess(response.data));
  } catch (error) {
    yield put(QuestionListError(error));
  }
}

function* onQuestionSearchSectionList(data) {
  try {
    const response = yield call(onQuestionSearchSectionListAsync, data.payload);
    yield put(QuestionSearchSectionListSuccess(response.data));
  } catch (error) {
    yield put(QuestionSearchSectionListError(error));
  }
}

function* onQuestionAdd(data) {
  try {
      const response = yield call(onQuestionAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(QuestionAddSuccess(response.data));
  } catch (error) {
      yield put(QuestionAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onQuestionDetail(data) {
  try {
    const response = yield call(onQuestionDetailAsync, data.payload);
    yield put(QuestionDetailSuccess(response.data.data));
  } catch (error) {
    yield put(QuestionDetailError(error));
  }
}

function* onQuestionUpdate(data) {
  try {
      const response = yield call(onQuestionUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(QuestionUpdateSuccess(response.data));
  } catch (error) {
      yield put(QuestionUpdateError(error));
  }
}

function* onQuestionUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onQuestionUploadAsync, file);
    if(response.message ==='success'){
      yield put(QuestionUploadSetSuccess(response));
    }
    else{
      yield put(QuestionUploadSetError(response));
    }
  } catch (error) {
    yield put(QuestionUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchQuestionList),
    fork(watchQuestionSearchSectionList),
    fork(watchQuestionAdd),
    fork(watchQuestionDetail),
    fork(watchQuestionUpdate),
    fork(watchQuestionUpload),
  ]);
} 